import { KeycloakConfig } from 'keycloak-js';

import { Servidor } from '../_classes/servidor';
import { Aplicacao } from './../_classes/aplicacao';

import { Injectable } from '@angular/core';
import { EMPTY, timer } from 'rxjs';
import { Retorno } from '../_classes/retorno';
import { NotificacaoService } from './notificacao.service';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  // Os valores definidos aqui serão substituídos pelos configurados no env.js,
  // caso o env.js seja carregado com sucesso.

  public production: boolean = false;
  public nome: string;
  public descricao: string;
  public apiUrl: string;
  public ssoUrl: string;
  public realm: string;
  public clientId: string;
  public redirectUri: string;
  public ambiente: string = 'desenv';
  public app: Aplicacao;
  public timeoutGenerico = 20000;
  public timeoutToast: number = 5000;
  public timeoutSnack = 5000;
  public timeoutBuscaNotificacao = 5000;
  public servidor: Servidor = null;
  public static servidor2: Servidor = null;
  public mostrarMenu: boolean = false;
  public enableDebug = true;
  public tNotificacoes: any;
  public notificacoesTotalNovas = 0;
  public notificacoesMostrando = false;
  public mobile = false;
  public bancoConectado = true;
  public ID_LOCALIDADE_COM_DIREITO = '';
  //public notificacaoValidou = false;
  //public notificacaoIgnorou = false;

  public keycloakConfig: KeycloakConfig;

  private _sNot: NotificacaoService;

  constructor() {
    //console.log('Envservice');
    const keyEnv = '__env';
    this.keycloakConfig = { url: '', realm: '', clientId: '' };
    const browserWindowEnv = window[keyEnv] || {};
    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    for (const key of Object.keys(browserWindowEnv)) {
      this[key] = browserWindowEnv[key];
    }
    this.production = this.ambiente == 'PRODUCAO' || this.ambiente == 'PROD';
  }

  encerrarTimers() {
    if (this.tNotificacoes) {
      this.tNotificacoes.unsubscribe();
    }
  }
}
